import FondationsServiceModel from '@/models/FondationsServiceModel';

export default class LoginCheckModel extends FondationsServiceModel {
	static get path(): string {
		return '/login_check';
	}

    public get token(): string {
		return this.get('token', '');
	}

	public get refreshToken(): string {
		return this.get('refresh_token', '');
	}
}